import React, { FunctionComponent, useState, useEffect } from 'react';
import TimePicker from 'rc-time-picker';
import moment, { Moment } from 'moment';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

export interface Props {
  time: Moment;
  handleTimeChange: (value: Moment) => any;
  disabled?: boolean;
  // styled-components generates a class name and we have to apply it to popupClassName
  className?: any;
  placeholder?: string;
}

const TimeHourPicker: FunctionComponent<Props> = ({ time, handleTimeChange, disabled, className, placeholder }) => {
  const [valueState, setValue] = useState(moment());

  useEffect(() => {
    setValue(time || null);
  }, [time]);

  const handleValueChange = (value: Moment) => {
    setValue(value);
    handleTimeChange(value);
  };

  return (
    <TimePicker
      className={className}
      popupClassName={className}
      showSecond={false}
      value={valueState}
      onChange={handleValueChange}
      allowEmpty={false}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};

// We must style this here so className can be passed to the TimeHourPicker
const StyledTimePicker = styled(TimeHourPicker)`
  height: 100%;
  & .rc-time-picker-input,
  & .rc-time-picker-panel-input {
    height: 100%;
    font-family: Roboto;
    font-size: ${({ theme }) => theme.font.sizes.medium};
    color: ${Colors.fontDarkGray};
    border-radius: 1px;
    font-weight: ${({ theme }) => theme.font.weights.light};

    &:disabled {
      background: none;
      cursor: pointer;
    }
  }

  & .rc-time-picker-panel-input-wrap {
    padding: 4px 7px;
  }

  & .rc-time-picker-panel-inner {
    box-shadow: none;
    margin-top: 3px;
  }

  & .rc-time-picker-panel-select::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  & .rc-time-picker-panel-combobox {
    display: flex;
  }
`;

export default StyledTimePicker;
